import { MarketplaceState } from '../marketplace-model'
import { Pagination } from '@/services/models/common-model'
import {
  MarketplaceFilters,
  OrderEntity,
  RequestState
} from '@/services/models/marketplace-service-model'

export const marketplaceOrders = (state: MarketplaceState): Array<OrderEntity> =>
  state.marketplaceOrders

export const nextLoadSuggestions = (
  state
): Pick<MarketplaceState, 'nextLoadSuggestions'> => state.nextLoadSuggestions

export const marketplacePagination = (state: MarketplaceState): Pagination =>
  state.pagination

export const marketplaceFilters = (state: MarketplaceState): MarketplaceFilters =>
  state.filters

export const marketplaceOrdersCount = (state: MarketplaceState): number =>
  state.pagination.totalCount

export const marketplaceOrderUpdatesCount = (state: MarketplaceState): number =>
  state.updates.length

export const updatedMarketplaceOrderIds = (state: MarketplaceState): Array<number> =>
  state.updatedSinceLastRefresh

export const currentMarketplaceTransportRequestState = (
  state: MarketplaceState
): RequestState | 'all' => state.filters.transportRequestState || 'all'
